export default "__VITE_ASSET__xQFihajX__"